import {useState} from 'react'
import {Button, Modal} from '@/components/atoms'
import {useAppDispatch, useAppSelector} from '@/store'
import {resetSalesTargetDisplayContentMedia, setSalesTargetDisplayContentMedia} from '@/store/slices/salesTargetSlice'
import {MediaCardForm} from '@/components/organisms'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {UploadFile} from '@/components/molecules'
import {useFileUpload} from '@/hooks/useFileUpload'
import {Constants} from '@/utils/constants/commonConstants'

function UploadMedia({setMediaCardFormData, mediaCardFormData, uploadFor = null}) {
  const dispatch = useAppDispatch()
  const initialFileErrorState = {feedbackType: 'info', helperText: ''}
  const [open, setOpen] = useState(false)
  const [mediaFile, setMediaFile] = useState([])
  const {onUploadFile} = useFileUpload()
  // const {fakeProgress} = useFakeProgress()
  const [fileError, setFileError] = useState(initialFileErrorState)
  const [error, setError] = useState(false)
  const salesTarget = useAppSelector(state => state.salesTarget)

  const isCloseModal = () => {
    dispatch(resetSalesTargetDisplayContentMedia())
    setMediaFile([])
    setOpen(false)
    setFileError(initialFileErrorState)
  }
  const isOpenModal = () => {
    setOpen(true)
  }

  const handleUpload = file => {
    onUploadFile(file, res => {
      setMediaFile([res.filePath])
    })
  }

  const handleError = err => {
    setFileError({feedbackType: 'error', helperText: err + '. Supported formats: .jpg,.png'})
  }

  const handleDelete = () => {
    dispatch(resetSalesTargetDisplayContentMedia())
    setMediaFile([])
  }

  const handleDone = () => {
    setOpen(false)
  }

  const handleMediaCardChange = data => {
    setMediaCardFormData(prevData => ({
      ...prevData,
      ...data,
    }))
  }

  return (
    <>
      <h1 className="mb-4 text-sm font-bold">Add Media</h1>
      <div className="mb-6 flex flex-wrap py-2" data-testid="uploadMediaBtn">
        <Button
          handleButton={isOpenModal}
          uiSchema={{
            size: 'large',
            title: 'Upload Media',
            variant: 'primary',
            disabled: mediaFile.length > 0,
          }}
        />
      </div>
      <Modal
        type={MODAL_TYPE.SMALL}
        isDark={true}
        onCloseModal={isCloseModal}
        onClickSecondaryButton={isCloseModal}
        onClickPrimaryButton={handleDone}
        primaryButtonText="Done"
        showTertiaryButton={false}
        showAuxiliaryButton={false}
        showSecondaryButton={true}
        showLink={false}
        showModal={open}
        title={'Upload Media'}
        primaryButtonDisabled={
          mediaFile.length == 0 || (Object.keys(fileError).length > 0 && fileError?.feedbackType === 'error') || error
        }
        content={
          <div className="media-upload">
            <UploadFile
              uploadFor={uploadFor}
              acceptedExtensions=".jpg,.png"
              description="Drag and drop your file here (only .jpg,.png)"
              label="Upload image file"
              variant={Constants.Edit}
              buttonLabel="Select from System Library"
              onUploadError={handleError}
              feedbackType={fileError.feedbackType}
              helperText={fileError.helperText}
              type="image"
              required={true}
              imageUri={salesTarget?.displayContentMedia?.imageUri}
              setFile={setMediaFile}
              uploadFileSuccess={setSalesTargetDisplayContentMedia}
              resetUploadFile={resetSalesTargetDisplayContentMedia}
              onUpload={handleUpload}
              fileSizeCheck={true}
              onSetError={setError}
            />
          </div>
        }
      />
      {mediaFile.length > 0 && (
        <MediaCardForm
          imageUri={salesTarget?.displayContentMedia?.imageUri}
          handleChange={handleMediaCardChange}
          handleDelete={handleDelete}
          mediaCardFormData={mediaCardFormData}
        />
      )}
    </>
  )
}

export default UploadMedia
